import { r as registerInstance, h } from './index-5faac9d7.js';
import { t as tryParse } from './index-39f51a91.js';
import { aE as CountrySelectorConstants } from './currency-49e0d692.js';
import { s as send, K as csExitToSchneiderEvent } from './analytics-74fe4f64.js';
import './_commonjsHelpers-7db8bc26.js';
import './analytics-b3108572.js';
import './lodash-7f024380.js';
import './_nodeUtil-549406aa.js';
import './_Stack-cf94d4e7.js';
import './number-fcf5283d.js';
import './navigation-83d2f79a.js';

const notScopeMessage = CountrySelectorConstants.NOT_SCOPED_MESSAGE;
const CountrySelector = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.onCountryLabelClicked = (event) => {
      const { origin, hash, href } = window.location;
      const selectedCountry = this.countriesData.find((ele) => ele.locale === event.detail.locale);
      if (!(selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.url))
        return;
      const browserTabUrl = new URL(href);
      const propogatedParams = new URL(href);
      browserTabUrl.searchParams.forEach((_, key) => {
        if (!this.nonPropagatedParams.includes(key))
          return;
        propogatedParams.searchParams.delete(key);
      });
      const linkUrl = `${origin}${selectedCountry.url}${propogatedParams.search}${hash || ''}`;
      send(csExitToSchneiderEvent, { link_url: linkUrl });
      document.location.href = linkUrl;
    };
    this._countrySelector = undefined;
    this._additionalData = undefined;
    this.countrySelectorData = undefined;
    this.addtionalData = undefined;
    this.nonPropagatedParams = undefined;
    this.locales = undefined;
    this.country_code = CountrySelectorConstants.COUNTRY_CODE;
    this.language_code = CountrySelectorConstants.LANGUAGE_CODE;
    this.toggle_click = CountrySelectorConstants.TOGGLE_CLICK;
    this.app_source = CountrySelectorConstants.APP_SOURCE;
    this.cs_endPoint = CountrySelectorConstants.CS_ENDPOINT;
    this.not_scoped_message = notScopeMessage;
    this.cs_title = undefined;
    this.countriesData = undefined;
  }
  componentWillLoad() {
    var _a, _b, _c;
    this.countrySelectorData = (_a = tryParse(this._countrySelector)) !== null && _a !== void 0 ? _a : this.countrySelectorData;
    this.addtionalData = (_b = tryParse(this._additionalData)) !== null && _b !== void 0 ? _b : null;
    this.nonPropagatedParams = ((_c = this.addtionalData) === null || _c === void 0 ? void 0 : _c.nonPropagatedParams) || [];
    const { countries, messages } = this.countrySelectorData || {};
    this.not_scoped_message = (messages === null || messages === void 0 ? void 0 : messages.empty) || CountrySelectorConstants.NOT_SCOPED_MESSAGE;
    this.cs_title = messages === null || messages === void 0 ? void 0 : messages.success;
    let locations = '';
    const localesList = [];
    countries === null || countries === void 0 ? void 0 : countries.forEach((element) => {
      const { code = '', lang = '' } = element;
      const locale = `${lang}_${code.toLowerCase()}`;
      element.locale = locale;
      localesList.push(locale);
    });
    this.countriesData = countries;
    locations = localesList.join(',');
    this.locales = locations;
  }
  render() {
    return (h("div", { class: "pes-country-selector-content" }, h("country-selector", { cs_endpoint: this.cs_endPoint, country_code: this.country_code, language_code: this.language_code, app_source: this.app_source, ref: () => {
        window.addEventListener('countryLabelClicked', this.onCountryLabelClicked);
      }, locales: this.locales, cs_title: this.cs_title, not_scoped_message: this.not_scoped_message, toggle_click: this.toggle_click })));
  }
};

export { CountrySelector as pes_country_selector };
